import { lazy } from 'solid-js'
import { messages } from '../../pages/lodgr-extension-demo-page/lodgr-extension-demo-page-routing.messages.en.js'

/*
    TENANT-5433. `/lodgr-extension-demo`

    The destination behind "Go to demo" on `/installed`.

    NO Lodgr chrome at all (`showHeader: false`, `showFooter: false`). The page
    renders a fictional booking site's own header and footer; wrapping Lodgr's
    header around it would make the demo unreadable and undercut the premise
    that you are looking at someone else's listing page.

    `noIndex` because the page presents a listing that does not exist —
    fabricated host, reviews, rating and prices. Indexing that would put
    invented accommodation content into search results under Lodgr's domain.
    Same treatment as `/browser-demo`, and the path is likewise absent from
    `sitemap-routes.js`. Neither stops someone who already has the URL; that is
    the accepted trade-off, as it is there.
*/
export default {
    component: lazy(() => import('../../pages/lodgr-extension-demo-page/lodgr-extension-demo-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/lodgr-extension-demo',
    showFooter: false,
    showHeader: false,
    titleMessage: messages.titleMessage,
}
